module.exports = __webpack_public_path__ + "fonts/IntegralCF-Bold.a03ed36.woff2";